/**
 * Created by Carsten Bühler
 * User: CBuehler on 27.01.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import ReactDOM from 'external/react-dom';
import PropTypes from 'external/prop-types';
import { AppContext } from '../app-context';

class ScrollableDataComponent extends React.Component {

    componentDidMount() {
        this.mounted = true;
    }


    getScrollContainerDomNode() {
        console.warn("Implement getScrollContainerDomNode() ");
        return ReactDOM.findDOMNode(this);
    }

    componentDidUpdate() {
        const list = this.props.list;

        const scrollContainer = this.getScrollContainerDomNode();

        if (scrollContainer) {
            let position = scrollContainer.scrollTop;
            let maxHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
            if (!list._loading && list._more && !list._error) {
                if (list._end < AppContext.DEFAULT_LIST_SIZE) {
                    //TODO is this hack really the best solution?
                    console.warn('initial list item size to small');
                    this.props.loadMoreRows({
                        startIndex: list._end,
                        stopIndex: list._end + AppContext.DEFAULT_LIST_SIZE
                    });
                }
            }
        } else if (this.mounted) {
            console.warn("ScrollContainerDomNode not found!", this);
        }
    }

    onScroll(list) {
        const scrollContainer = this.getScrollContainerDomNode();
        if (!list._loading && list._more) {
            const maxHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
            if (maxHeight - scrollContainer.scrollTop < 1) {
                this.props.loadMoreRows({
                    startIndex: list._end,
                    stopIndex: list._end + AppContext.DEFAULT_LIST_SIZE
                });
            }
        }
    }

    render() {
        return this.renderComponent();
    }
}

ScrollableDataComponent.propTypes = {
    ListItem: PropTypes.func.isRequired,
    activeIds: PropTypes.object,
    disabledIds: PropTypes.object,
    list: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    className: PropTypes.string,
    propName: PropTypes.string,
    onClick: PropTypes.func,
    loadMoreRows: PropTypes.func.isRequired
};

export default ScrollableDataComponent;



// WEBPACK FOOTER //
// ./js/components/ScrollableDataComponent.jsx